import {
  TableBlockProps,
  TableBlock as V3TableBlock,
} from '@stadionhq-v3/base-ui';
import classnames from 'classnames';
import styles from './tableBlock.module.scss';

const TableBlock = ({
  classNames,
  theme = {
    themeId: 'default1',
    title: 'Default 1',
  },
  ...props
}: TableBlockProps) => {
  const classes = classnames(
    [
      styles.tokens,
      styles.tableBlockTokens,
      styles.tableBlock,
      theme?.themeId ? styles[theme.themeId] : styles.colourTheme1,
    ],
    classNames
  );

  return <V3TableBlock classNames={[classes]} {...props} theme={theme} />;
};

export default TableBlock;
